import { render } from "./ModelButtonOverview.vue?vue&type=template&id=031b534c&scoped=true"
import script from "./ModelButtonOverview.vue?vue&type=script&lang=js"
export * from "./ModelButtonOverview.vue?vue&type=script&lang=js"

import "./ModelButtonOverview.vue?vue&type=style&index=0&id=031b534c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031b534c"]])

export default __exports__